import { IOfferedShipmentOfferTypeEnum, Maybe } from 'types/FMSGraphqlTypes'
import { getRemainingTimeInMinutes } from './getRemainingTimeInMinutes'

interface IGetOfferExpirationMessageProps {
  offerExpiresAt: Maybe<string>
  offerType: IOfferedShipmentOfferTypeEnum
}

export const getOfferExpirationMessage = ({
  offerExpiresAt,
  offerType,
}: IGetOfferExpirationMessageProps): string => {
  const remainingMinutes = getRemainingTimeInMinutes(offerExpiresAt)

  switch (offerType) {
    case IOfferedShipmentOfferTypeEnum.WaterfallOffered:
      if (remainingMinutes >= 5) {
        return `Offering to more carriers in ${remainingMinutes} ${
          remainingMinutes === 1 ? 'min' : 'mins'
        }`
      }
      if (remainingMinutes < 5 && remainingMinutes > 0) {
        return 'Offering to more carriers soon.'
      }
      return 'Other carriers are seeing this load.'
    case IOfferedShipmentOfferTypeEnum.BidAccepted:
    case IOfferedShipmentOfferTypeEnum.ManualOffer:
    default:
      return remainingMinutes > 0
        ? `Expires in ${remainingMinutes} ${remainingMinutes === 1 ? 'min' : 'mins'}`
        : 'Expiring soon'
  }
}
